import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/Button';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Головна',
    target: 'hero'
  }, {
    name: 'Про нас',
    target: 'founder'
  }, {
    name: 'Активності',
    target: 'activities'
  }, {
    name: 'Новини',
    target: 'news'
  }, {
    name: 'Контакти',
    target: 'footer'
  }];
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      const headerOffset = 80;
      const elementPosition = el.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: elementPosition - headerOffset,
        behavior: 'smooth'
      });
    }
    setIsMobileMenuOpen(false);
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#0A5E5C] shadow-lg py-3' : 'bg-[#0A5E5C]/90 backdrop-blur-sm py-5'}`} data-id="element-310">
      <div className="container mx-auto px-4 md:px-6" data-id="element-311">
        <div className="flex items-center justify-between" data-id="element-312">
          {/* Logo */}
          <button onClick={() => scrollTo('hero')} className="flex items-center gap-2 group" data-id="element-313">
            <div className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center group-hover:bg-white/20 transition-colors" data-id="element-314">
              <span className="text-[#D4A843] font-serif font-bold text-xl" data-id="element-315">
                FG
              </span>
            </div>
            <span className="text-white font-serif font-bold text-xl tracking-wide" data-id="element-316">
              Fair Gaming Space NGO
            </span>
          </button>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-317">
            {navLinks.map(link => <button key={link.name} onClick={() => scrollTo(link.target)} className="text-white/90 hover:text-[#D4A843] font-medium transition-colors text-sm uppercase tracking-wider" data-id="element-318">
                {link.name}
              </button>)}

            {/* Language Switcher */}
            <div className="flex items-center gap-1 ml-2 bg-white/10 rounded-full p-1" data-id="element-319">
              <span className="px-3 py-1 rounded-full bg-white/20 text-white text-xs font-bold tracking-wider cursor-default" data-id="element-320">
                УКР
              </span>
              <a href="https://en.fgsu.org" className="px-3 py-1 rounded-full text-white/60 hover:text-white text-xs font-bold tracking-wider transition-colors" data-id="element-321">
                ENG
              </a>
            </div>

            <Button variant="secondary" size="sm" className="ml-2" data-id="element-322">
              Підтримати
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button className="md:hidden text-white p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-323">
            {isMobileMenuOpen ? <X size={24} data-id="element-324" /> : <Menu size={24} data-id="element-325" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-[#0A5E5C] border-t border-white/10 shadow-xl p-4 flex flex-col gap-4" data-id="element-326">
          {navLinks.map(link => <button key={link.name} onClick={() => scrollTo(link.target)} className="text-white/90 hover:text-[#D4A843] font-medium py-2 px-4 rounded-md hover:bg-white/5 transition-colors text-left" data-id="element-327">
              {link.name}
            </button>)}

          {/* Mobile Language Switcher */}
          <div className="flex items-center gap-1 bg-white/10 rounded-full p-1 self-start" data-id="element-328">
            <span className="px-3 py-1 rounded-full bg-white/20 text-white text-xs font-bold tracking-wider cursor-default" data-id="element-329">
              УКР
            </span>
            <a href="https://en.fgsu.org" className="px-3 py-1 rounded-full text-white/60 hover:text-white text-xs font-bold tracking-wider transition-colors" data-id="element-330">
              ENG
            </a>
          </div>

          <Button variant="secondary" fullWidth onClick={() => setIsMobileMenuOpen(false)} data-id="element-331">
            Підтримати
          </Button>
        </div>}
    </header>;
}